import { render, staticRenderFns } from "./LinkGroupsByClientIdDialog.vue?vue&type=template&id=eeb20d40&scoped=true"
import script from "./LinkGroupsByClientIdDialog.vue?vue&type=script&lang=js"
export * from "./LinkGroupsByClientIdDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb20d40",
  null
  
)

export default component.exports